export default "__VITE_ASSET__Ckuy4HwM__"